import { computed } from 'vue';
import { RemainingRouteNames } from '@/types/i-router';
import { LoadingStates } from '@/types/i-loading';
import InitialRouteHandler from '@/plugins/initial-route-handler';
import store from '@/store';

class StartUpHandler {
	private rootElement: HTMLElement | null = null;
	private startRoute = '';

	private isListingSession = computed((): boolean => {
		return store.getters.isListingSession();
	});

	constructor() {
		this.setRootElement();
	}

	public handleFirstStartUpActions(): void {
		const standAloneLogin = webpackDefinitions.STAND_ALONE_LOGIN === 'true';

		// Present when we are on main screen in campaign editor.
		const campaignId: number = parseInt(this.rootElement?.dataset.campaignId || '0', 10);
		const campaignStartDate: number = parseInt(this.rootElement?.dataset.campaignStartDate || '0', 10);

		// Present when we are in the study / organisation editor.
		this.startRoute = this.rootElement?.dataset.startRoute || '';
		const studyId: number = parseInt(this.rootElement?.dataset.studyId || '0', 10);
		const organisationId: number = parseInt(this.rootElement?.dataset.organisationId || '0', 10);

		const listingOverviewRoutes = [
			RemainingRouteNames.ORGANISATION_LISTING_OVERVIEW,
			RemainingRouteNames.STUDY_LISTING_OVERVIEW
		];
		store.mutations.setIsListingSession(listingOverviewRoutes.includes(this.startRoute as RemainingRouteNames));
		store.mutations.setStudyId(studyId);
		store.mutations.setOrganisationId(organisationId);
		store.mutations.setCampaignId(campaignId);
		store.mutations.setCampaignStartDate(campaignStartDate);
		store.mutations.setStandAloneLogin(standAloneLogin);

		this.handleRestartActions();
	}

	public handleRestartActions(): void {
		store.mutations.setLoadingState(this.isListingSession.value ? LoadingStates.INACTIVE : LoadingStates.STARTING);

		InitialRouteHandler.setInitialRoute(this.startRoute);
	}

	private setRootElement(): void {
		this.rootElement = document.getElementById('CampaignEditor');
		if (this.rootElement) {
			return;
		}

		this.rootElement = document.getElementById('GeoTargetingMS');
	}
}

export default new StartUpHandler();
